<template>
  <div class="has-text-centered">
    <div class="mb-2">
      <b-button
        v-if="!praised"
        type="is-dark"
        icon-left="star"
        rounded
        @click="praise"
      >
        Praise
      </b-button>
      <b-icon v-else pack="fas" icon="star" type="is-warning" size="is-large" />
    </div>
    <b-collapse :open="false" aria-id="commentId">
      <template #trigger="props">
        <a aria-controls="commentId">
          <b-icon :icon="!props.open ? 'plus' : 'minus'"></b-icon>
          {{ !props.open ? "Provide feedback to student" : "Hide" }}
        </a>
      </template>
      <div>
        <b-input
          v-model="feedback"
          maxlength="900"
          type="textarea"
          placeholder="Use this field to provide feedback to the student on their recording."
        />
        <b-button
          :type="edit ? 'is-warning' : 'is-info'"
          expanded
          :loading="submittingFeedback"
          @click="submitFeedback"
        >
          {{ edit ? "Update feedback" : "Submit feedback" }}
        </b-button>
        <p v-if="submissionFailed" class="is-size-7 has-text-danger">
          An error occurred. Give it a few seconds or try refreshing the page.
        </p>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import dataService from "../../services/dataService";
export default {
  props: ["recordingGuid", "praised", "edit"],
  data() {
    return {
      feedback: "",
      submittingFeedback: false,
      submissionFailed: false
    };
  },
  methods: {
    praise() {
      // no need to await for the praise to succeed
      dataService.praiseStudentRecording(this.recordingGuid);
      this.$emit("praised");
    },
    async submitFeedback() {
      if (!this.feedback) return;
      this.submissionFailed = false;
      this.submittingFeedback = true;
      const success = await dataService.submitFeedbackForStudentRecording(
        this.recordingGuid,
        this.feedback
      );
      if (success) {
        this.$emit("feedbackSubmitted", this.feedback);
        this.feedback = "";
      } else {
        this.submissionFailed = true;
      }

      this.submittingFeedback = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
